if (!customElements.get('sd-rebrand-buy-button')) {
  class SdRebrandBuyButton extends HTMLElement {
    constructor () {
      super()
      this.form = this.querySelector('form')
      this.button = this.querySelector('button[type="submit"]')
      this.directToCheckout = this.dataset.checkout === 'true'

      // Capture custom label — skip icon span, target the last <span> (the label)
      const spans = this.button?.querySelectorAll('span')
      const labelSpan = spans?.length ? spans[spans.length - 1] : null
      this.customLabel = labelSpan ? labelSpan.textContent.trim() : ''
    }

    connectedCallback () {
      if (!this.form) return
      this.form.addEventListener('submit', this.onSubmit.bind(this))

      // Sync variant ID when variant picker changes selection
      this.variantInput = this.form.querySelector('input[name="id"]')
      this.onVariantChanged = this.onVariantChanged.bind(this)
      document.addEventListener('variantChanged', this.onVariantChanged)
      this.setupPubSub()
      this.syncInitialVariant()
    }

    syncInitialVariant () {
      // Read the default variant from the variant picker's data-selected-variant JSON
      const variantJson = document.querySelector('variant-selects [data-selected-variant]')
      if (variantJson && this.variantInput) {
        try {
          const variant = JSON.parse(variantJson.textContent)
          if (variant && variant.id) {
            this.variantInput.value = variant.id
          }
        } catch (e) { /* ignore parse errors */ }
      }
    }

    disconnectedCallback () {
      document.removeEventListener('variantChanged', this.onVariantChanged)
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber()
      }
    }

    onVariantChanged (evt) {
      if (!this.variantInput || !evt.detail || !evt.detail.variantId) return
      this.variantInput.value = evt.detail.variantId
    }

    setupPubSub () {
      // eslint-disable-next-line no-undef
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        // eslint-disable-next-line no-undef
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event.data || !event.data.variant) return
          const variant = event.data.variant
          if (this.variantInput) {
            this.variantInput.value = variant.id
          }
          if (this.button) {
            this.button.disabled = !variant.available
            const spans = this.button.querySelectorAll('span')
            const labelSpan = spans.length ? spans[spans.length - 1] : null
            if (labelSpan && !variant.available) {
              labelSpan.textContent = window.variantStrings?.soldOut || 'Sold out'
            } else if (labelSpan && this.customLabel) {
              labelSpan.textContent = this.customLabel
            }
          }
        })
      }
    }

    onSubmit (evt) {
      evt.preventDefault()
      evt.stopPropagation()

      if (this.button.disabled) return

      this.button.disabled = true
      this.button.classList.add('is-loading')

      const variantId = parseInt(this.form.querySelector('input[name="id"]').value, 10)

      // Use plain form (no action="/cart/add", no shopify-product-form class)
      // so third-party scripts (SmartCart, Elevar) don't intercept and duplicate the request
      const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
      const bodyObj = {
        items: [{ id: variantId, quantity: 1 }]
      }

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        bodyObj.sections = cartDrawer.getSectionsToRender().map((s) => s.id)
        bodyObj.sections_url = window.location.pathname
        cartDrawer.setActiveElement(document.activeElement)
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(bodyObj)
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status && data.status !== 200) {
            this.handleError(data.description || 'Could not add to cart.')
            return
          }

          if (this.directToCheckout) {
            window.location.href = window.Shopify.routes.root + 'checkout'
            return
          }

          // Add to cart: update cart drawer / notification, or redirect to cart
          if (cartDrawer) {
            if (typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(data)
            } else {
              cartDrawer.classList.add('is-active')
            }

            // eslint-disable-next-line no-undef
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              // eslint-disable-next-line no-undef
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sd-rebrand-buy-button', cartData: data })
            }
          } else {
            window.location.href = window.Shopify.routes.root + 'cart'
          }
        })
        .catch(() => {
          this.handleError('Something went wrong. Please try again.')
        })
        .finally(() => {
          this.resetButton()
        })
    }

    handleError (message) {
      this.resetButton()
      const errorEl = this.querySelector('.sd-rebrand-buy-button__error')
      if (errorEl) {
        errorEl.textContent = message
        errorEl.removeAttribute('hidden')
      } else {
        console.error('[sd-rebrand-buy-button]', message)
      }
    }

    resetButton () {
      this.button.disabled = false
      this.button.classList.remove('is-loading')
      // Restore custom label in case it was overwritten
      if (this.customLabel) {
        const spans = this.button.querySelectorAll('span')
        const labelSpan = spans.length ? spans[spans.length - 1] : null
        if (labelSpan) labelSpan.textContent = this.customLabel
      }
    }
  }

  customElements.define('sd-rebrand-buy-button', SdRebrandBuyButton)
}
